import {Component, OnInit} from '@angular/core';
import {AutorunComponent} from '@myshared/autorun.component';
import {Model} from '../../app.model';
import {CustomerService} from '../customer.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CountryService} from '../../country/country.service';
import {SubscriptionService} from '../../subscription/subscription.service';
import {Subscription} from '../../subscription/subscription.model';
import {Customer} from '../customer.model';
import {Country} from "../../country/country.model";
import {MessageService} from "primeng/api";
import {I18NextService} from "angular-i18next";
import {FormEmitter} from "../../forms/form.component";
import { showElectronicInvoiceMailInputField } from 'src/app/company/company.utils';

@Component({
    selector: 'app-customer-details',
    templateUrl: './customer-details.component.html',
    styleUrls: [],
    standalone: false
})
export class CustomerDetailsComponent extends AutorunComponent implements OnInit {
  public customerId: string;
  public customer: Customer;
  public countries: Country[];

  customerSubscriptions: Subscription[];

  constructor(private route: ActivatedRoute,
              private m: Model,
              private customerService: CustomerService,
              private countryService: CountryService,
              private subscriptionService: SubscriptionService,
              private messageService: MessageService,
              private i18next: I18NextService,
              private router: Router) {
    super();
  }

  ngOnInit() {
    this.customerId = this.route.snapshot.paramMap.get('customerId');
    this.customerService.refresh();
    this.countryService.refresh();
    this.subscriptionService.refresh();

    this.autorun(() => {
      this.countries = this.m.country.countries;
      this.customer = this.m.customer.customers.find((x) => x.id == this.customerId);
      if (this.customer) {
        this.customerSubscriptions = this.m.subscription.subscriptions.filter(s => this.customer.appliance_ids.indexOf(s.appliance_id as any) !== -1);
      }
    });
  }

  get showElectronicInvoiceMailInputField(): boolean {
    return showElectronicInvoiceMailInputField(this.customer?.tenant);
  }

  onSubmit(form: FormEmitter<Customer>) {
    const customer = form.data;
    this.customerService.update(customer)
      .subscribe(r => {
        this.messageService.add({
          severity: 'success',
          summary: this.i18next.t('company_update_success_summary') as string,
          detail: this.i18next.t('company_update_success_detail') as string
        });
        this.router.navigate(['/customers'])
      });
  }

  onAddSubscription() {
    this.router.navigate(['/subscriptions/select-product'], {
      queryParams: { customerid: this.customerId }
    });
  }

  public onBack() {
    this.router.navigate(['/customers']);
  }

}
